module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-18.9766c544.png";